module.exports = __webpack_public_path__ + "static/media/cafe24-body-product.4a0e0848.png";